import type { ComponentProps, ReactNode } from "react"

import { cn } from "../lib/cn"

function Cronologia({ className, ...props }: ComponentProps<"ol">) {
  return <ol className={cn("m-0 flex list-none flex-col p-0", className)} {...props} />
}

function ItemDaCronologia({
  quando,
  detalheDoQuando,
  titulo,
  descricao,
  marcas,
}: {
  quando: ReactNode
  detalheDoQuando?: ReactNode
  titulo: ReactNode
  descricao?: ReactNode
  marcas?: ReactNode
}) {
  return (
    <li className="relative grid grid-cols-[5.5rem_1rem_minmax(0,1fr)] gap-x-3 pb-6 before:absolute before:top-5 before:bottom-0 before:left-[calc(5.5rem+0.75rem+0.5rem-0.5px)] before:w-px before:bg-(--borda-forte) last:pb-0 last:before:hidden max-[767px]:grid-cols-[4.5rem_1rem_minmax(0,1fr)] max-[767px]:before:left-[calc(4.5rem+0.75rem+0.5rem-0.5px)]">
      <span data-slot="quando-da-cronologia" className="flex flex-col items-end pt-0.5 text-right text-(length:--texto-xs) text-(--tinta-3) tabular-nums">
        <span className="font-medium">{quando}</span>
        {detalheDoQuando !== undefined && <span>{detalheDoQuando}</span>}
      </span>
      <span className="flex justify-center pt-1">
        <span
          data-slot="marcador-da-cronologia"
          aria-hidden="true"
          className="relative z-[1] size-3.5 rounded-full border-2 border-(--borda-forte) bg-(--painel)"
        />
      </span>
      <div className="flex min-w-0 flex-col gap-1">
        <span data-slot="titulo-da-cronologia" className="text-(length:--texto-base) font-semibold text-(--tinta) wrap-anywhere">
          {titulo}
        </span>
        {descricao !== undefined && descricao !== null && (
          <div data-slot="descricao-da-cronologia" className="text-(length:--texto-sm) text-(--tinta-2) wrap-anywhere">
            {descricao}
          </div>
        )}
        {marcas !== undefined && marcas !== null && (
          <span data-slot="marcas-da-cronologia" className="mt-1 flex flex-wrap items-center gap-1.5">
            {marcas}
          </span>
        )}
      </div>
    </li>
  )
}

export { Cronologia, ItemDaCronologia }
